/*
File: dropdown-menu.js
Version: 1.0
*/

function showDropdown() {
  document.getElementById("dropdown-arrow").classList.toggle("rotate");
  document.getElementById("dropdown-items").classList.toggle("show");
}

function hideDropdown(e,f) {
  document.getElementById("dropdown-arrow").classList.toggle("rotate");
  document.getElementById("dropdown-items").classList.toggle("show");
  document.getElementById("button-text").innerHTML = e;
  document.getElementById("button-url").href = f;
}

window.addEventListener('click', function(e){
  if (!document.getElementById("dropdown-items").contains(e.target) && (!document.getElementById("dropdown-button").contains(e.target))){
    document.getElementById("dropdown-arrow").classList.remove("rotate");
    document.getElementById("dropdown-items").classList.remove("show");
  } 
})

